<script setup lang="ts">
const {nestingLevel = 1} = defineProps<{
    nestingLevel?: number;
}>();
</script>

<template>
  <p
    class="font-medium"
    :class="{
      'text-xl': nestingLevel === 1,
      'text-lg': nestingLevel === 2,
      'text-md': nestingLevel === 3,
      'text-sm': nestingLevel >= 4,
    }"
  >
    <slot />
  </p>
</template>

<style scoped>

</style>
